import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition } from "vue";
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "main-nav"
};
const _hoisted_3 = {
  class: "flex-row footer-nav"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = ["href"];
const _hoisted_6 = {
  class: "newsletter-container"
};
const _hoisted_7 = {
  class: "flex-col sub-footer"
};
const _hoisted_8 = {
  class: "copyright"
};
const _hoisted_9 = {
  class: "legal-links"
};
import { ref, computed, watch, reactive } from 'vue';
import Newsletter from './Newsletter.vue';
import SocialLinks from './SocialLinks.vue';
import ConsentBanner from '@/components/PrivacyPolicy/ConsentBanner.vue';
import { registerResize } from '../composables/windowWatcher';
import { consentStatus } from '@/composables/consent';
import { useRoute } from 'vue-router';
export default {
  __name: 'Footer',
  setup(__props) {
    const route = useRoute();
    const consentBanner = ref(null);
    const state = reactive({
      size: null
    });
    const links = reactive({
      Company: [{
        name: 'About Us',
        destination: {
          path: '/about'
        }
      }, {
        name: 'Press',
        destination: {
          name: 'Press'
        }
      }, {
        name: 'Affiliate Program',
        destination: {
          path: '/affiliate-program'
        }
      }, {
        name: 'Academic Request',
        destination: {
          name: 'EduSiteLicenseInquiry'
        }
      }, {
        name: 'Careers',
        destination: {
          path: '/careers'
        }
      }],
      Products: [{
        name: 'AutoTune Editions',
        destination: {
          name: 'Auto-Tune'
        }
      }, {
        name: 'AI Vocal Chain',
        destination: {
          name: 'AiPowered'
        }
      }, {
        name: 'Creative Effects',
        destination: {
          name: 'VocalEffects'
        }
      }, {
        name: 'Subscription Plan',
        destination: {
          name: 'Subscriptions',
          params: {
            slug: 'unlimited'
          }
        }
      }, {
        name: 'Download Manager',
        destination: {
          name: 'SoftwareDownload'
        }
      }, {
        name: 'Demo Downloads',
        destination: {
          path: '/demo-downloads'
        }
      }, {
        name: 'Special Offers',
        destination: {
          path: '/auto-tune-special-offers'
        }
      }],
      Support: [{
        name: 'Customer Support',
        link: 'https://antaresaudiotechnologies.my.site.com/s/'
      }, {
        name: 'FAQ',
        link: 'https://antaresaudiotechnologies.my.site.com/s/topic/0TO4V000000oNAZWA2/faqs/'
      }, {
        name: 'Tutorials',
        destination: {
          name: 'LearningCenter'
        }
      }, {
        name: 'Artists',
        destination: {
          name: 'Artists'
        }
      }, {
        name: 'Compare AutoTune Editions',
        destination: {
          name: 'Compare'
        }
      }, {
        name: 'DAW Compatibility',
        destination: {
          path: '/daw-compatibility'
        }
      }, {
        name: 'Product Manuals',
        destination: {
          name: 'Documentation'
        }
      }]
    });
    const height = computed(() => `${state.size?.height ?? 0}px`);
    const mainColumnsBasis = computed(() => {
      const numColumns = Object.keys(links).length;
      return `${24 / numColumns / 24 * 100}%`;
    });
    const showConsentBanner = computed(() => {
      return consentStatus.value === -1 && !route.fullPath.includes('my-account');
    });
    const stopWatching = watch(consentBanner, (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        state.size = registerResize(consentBanner.value.$el, ['height']);
        stopWatching(); // Stop watching after the first change
      }
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_col = _resolveComponent("el-col");
      return _openBlock(), _createElementBlock("footer", {
        style: _normalizeStyle({
          '--consent-banner-height': height.value
        })
      }, [_createVNode(_component_el_row, {
        class: "footer-wrapper",
        align: "middle",
        justify: "center",
        "data-lazy-bg": "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/backgrounds/images_webp/Blue_light_smoke_on_a_black_background.webp",
        "data-lazy-bg-tablet": "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/backgrounds/images_webp/Blue_light_smoke_on_a_black_background_mobile.webp",
        "data-lazy-bg-mobile": "https://antares-web-frontend.sfo3.cdn.digitaloceanspaces.com/backgrounds/images_webp/Blue_light_smoke_on_a_black_background_mobile.webp",
        id: "footer"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_row, {
          class: "title",
          align: "middle",
          justify: "center"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("h4", null, "Unlock Your Voice.", -1)])),
          _: 1
        }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links, (categoryLinks, category) => {
          return _openBlock(), _createElementBlock("div", {
            class: "footer-nav-col",
            key: category,
            style: _normalizeStyle({
              '--basis-sm': mainColumnsBasis.value
            })
          }, [_createElementVNode("h5", null, _toDisplayString(category), 1), _createVNode(_component_el_row, {
            class: "footer-nav-row"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              class: "flex-col",
              span: 12
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryLinks.slice(0, Math.ceil(categoryLinks.length / 2)), link => {
                return _openBlock(), _createElementBlock(_Fragment, {
                  key: link.name
                }, [link.destination ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: link.destination
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(link.name), 1)]),
                  _: 2
                }, 1032, ["to"])) : link.link ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: link.link,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, _toDisplayString(link.name), 9, _hoisted_4)) : _createCommentVNode("", true)], 64);
              }), 128))]),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              class: "flex-col",
              span: 12
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryLinks.slice(Math.ceil(categoryLinks.length / 2)), link => {
                return _openBlock(), _createElementBlock(_Fragment, {
                  key: link.name
                }, [link.destination ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: link.destination
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(link.name), 1)]),
                  _: 2
                }, 1032, ["to"])) : link.link ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: link.link,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, _toDisplayString(link.name), 9, _hoisted_5)) : _createCommentVNode("", true)], 64);
              }), 128))]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)], 4);
        }), 128))]), _createElementVNode("div", _hoisted_6, [_createVNode(Newsletter)])])])]),
        _: 1
      }), _createVNode(_Transition, {
        name: "consent",
        appear: ""
      }, {
        default: _withCtx(() => [showConsentBanner.value ? (_openBlock(), _createBlock(ConsentBanner, {
          key: 0,
          ref_key: "consentBanner",
          ref: consentBanner
        }, null, 512)) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "center",
        align: "bottom",
        class: "sub-footer-wrapper"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_row, {
          align: "middle",
          justify: "space-between",
          class: "sub-footer-row"
        }, {
          default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "trademarks"
          }, [_createElementVNode("span", {
            ignore: ""
          }, "Evo™"), _createTextVNode(" and "), _createElementVNode("span", {
            ignore: ""
          }, "Auto-Motion™"), _createTextVNode(" are trademarks and "), _createElementVNode("span", {
            ignore: ""
          }, "AutoTune®"), _createTextVNode(", "), _createElementVNode("span", {
            ignore: ""
          }, "Auto-Tune®"), _createTextVNode(", "), _createElementVNode("span", {
            ignore: ""
          }, "Antares®"), _createTextVNode(", "), _createElementVNode("span", {
            ignore: ""
          }, "AVOX®"), _createTextVNode(", "), _createElementVNode("span", {
            ignore: ""
          }, "Harmony Engine®"), _createTextVNode(", "), _createElementVNode("span", {
            ignore: ""
          }, "Mic Mod®"), _createTextVNode(", and "), _createElementVNode("span", {
            ignore: ""
          }, "Solid-Tune®,"), _createTextVNode(" are registered trademarks of "), _createElementVNode("span", {
            ignore: ""
          }, "Antares Audio Technologies"), _createTextVNode(". ")], -1)), _createVNode(SocialLinks, {
            class: "footer-social-links"
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          align: "middle",
          justify: "space-between",
          class: "sub-footer-row"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, " All Materials ©" + _toDisplayString(new Date().getFullYear()) + " Antares Audio Technologies. ", 1), _createElementVNode("div", _hoisted_9, [_createVNode(_component_router_link, {
            to: {
              name: 'PrivacyPolicy'
            }
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode(" Privacy Policy ")])),
            _: 1
          }), _cache[6] || (_cache[6] = _createElementVNode("span", {
            style: {
              "color": "var(--el-color-white)"
            }
          }, "·", -1)), _createVNode(_component_router_link, {
            to: {
              name: 'RefundsPolicy'
            }
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode(" Refunds Policy ")])),
            _: 1
          }), _cache[7] || (_cache[7] = _createElementVNode("span", {
            style: {
              "color": "var(--el-color-white)"
            }
          }, "·", -1)), _createVNode(_component_router_link, {
            to: {
              path: '/terms-of-service'
            }
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode(" Terms of Service ")])),
            _: 1
          }), _cache[8] || (_cache[8] = _createElementVNode("span", {
            style: {
              "color": "var(--el-color-white)"
            }
          }, "·", -1)), _createVNode(_component_router_link, {
            to: {
              path: '/software-attributions'
            }
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" Software Attributions ")])),
            _: 1
          })])]),
          _: 1
        })])]),
        _: 1
      })], 4);
    };
  }
};